import { fetcherConfig } from '../../lib/api-fetcher';
import { z } from 'zod';
import { createResourceClient } from '@repo/api-client';
import { type ProductTypeListItem, type ProductTypeDetail } from './types';


const productTypeListItemSchema = z.object({
  id: z.string(),
  productCode: z.string(),
  displayName: z.string(),
  isActive: z.boolean(),
  version: z.number(),
});

const productTypeDetailSchema = productTypeListItemSchema.extend({
  parameterSchema: z.record(z.string(), z.any()),
  cycleEngine: z.string(),
});

// Registry is read-only in V1 — no create/update operations
export const productClient = createResourceClient<
  ProductTypeListItem,
  ProductTypeDetail,
  never,
  never
>(
  fetcherConfig,
  {
    path: '/staff/v1/product-types',
    schemas: {
      listItem: productTypeListItemSchema,
      detail: productTypeDetailSchema,
      create: z.never(),
      update: z.never(),
    },
  }
);
